import React, { useEffect, useMemo } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Divider,
  TextField,
} from "@mui/material";
import { convertDateToWords } from "../utils/dateToWords";
// import logo from "../10/SCHOOL/logo.jpg"

const SinglePageMarksheetReceipt = ({ receiptData, school, setTemID }) => {
  // const [activities, setActivities] = useState([
  //   { name: "Formative Assessment-I" },
  //   { name: "Formative Assessment-II" },
  //   { name: "Final Exam" },
  // ]);

  // const [totalGrade, setTotalGrade] = useState([
  //   { name: "Semester" },
  //   { name: "Education" },
  //   { name: "Co-Curricular" },
  //   { name: "Total" },
  //   { name: "Remarks" },
  //   { name: "Class Teacher Sign" },
  // ]);

  const student = receiptData.data;//[];
  const receiptId = `marksheet`;

  useEffect(() => {
    if (setTemID) {
      setTemID(receiptId);
    }
  }, [receiptData, setTemID, receiptId]);

  // extract unique subjects
  const subjects = useMemo(() => {
    const allMarks = student.flatMap((ms) => ms.marks);
    const unique = [...new Map(allMarks.map((m) => [m.subjectName.trim(), m])).values()];
    return unique.sort((a, b) =>
      a.subjectName.toLowerCase().localeCompare(b.subjectName.toLowerCase())
    );
  }, [student]);

  // quick lookup
  const findMark = (examType, subject) => {
    const term = student.find((m) => m.examType?.trim().toLowerCase()
    .includes(examType?.trim().toLowerCase()));
    return term?.marks.find(
      (s) => s.subjectName.trim().toLowerCase() === subject.trim().toLowerCase()
    );
  };

  const getTotals = (examType) => {
    const term = student.find((m) => m.examType?.trim().toLowerCase()
    .includes(examType?.trim().toLowerCase()));
    if (!term) return { max: 0, obt: 0, grade: "-" };
    const max = term.marks.reduce((sum, s) => sum + (s.maxMark || 0), 0);
    const obt = term.marks.reduce((sum, s) => sum + (s.marksObtained || 0), 0);
    return { max, obt, grade: term.grade };
  };


  // const addActivity = () => {
  //   const newName = `Activity-${activities.length + 1}`;
  //   setActivities([...activities, { name: newName }]);
  // };

  const toCamelCase = (str) => {
    return str
      ?.toLowerCase()
      .replace(/[^a-zA-Z0-9 ]/g, '')
      .split(' ')
      .map((word, index) =>
        index === 0
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(' ');
  };

  const t1 = getTotals("First");
  const t2 = getTotals("Second");
  const t3 = getTotals("Final");

  const studentInfo = () => {
    const data = student.find((m) => m.examType?.trim().toLowerCase()
    .includes('first'));
    return (
      <Box sx={{ lineHeight: 2 }}>
        <ProfileLine label="Name of the student" value={toCamelCase(`${data?.name} ${data?.last}`)} />
        <ProfileLine label="Father’s name" value={toCamelCase(`${data?.father}  ${data?.last}`)} />
        <ProfileLine label="Mother’s name" value={toCamelCase(`${data?.mother}  ${data?.last}`)} />
        <ProfileLine
          label="Studied"
          value={`${data?.classRoom?.standard} | Roll No : ${data?.classRoom?.rollNumber || ""}`}
        />
        <ProfileLine
          label="Admission No."
          value={`${data?.id || ""}  |  Caste: ${data?.caste || ""}`}
        />
        <ProfileLine
          label="Date of Birth"
          value={new Date(data?.birthday).toLocaleDateString("en-GB")}
        />

        <Typography><strong>{"(In words) : "}</strong> {convertDateToWords(data?.birthday)}
        </Typography>
      </Box>
    )
  };

  function ProfileLine({ label, value }) {
    return (
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "220px auto",  // FIXED SPACE like screenshot
          mb: 0.5,
        }}
      >
        <Typography sx={{ fontWeight: "bold" }}>{label} :</Typography>
        <Typography>{value}</Typography>
      </Box>
    );
  }


  return (
    <Box id={receiptId}>

      <Box sx={{
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'space-around',
        alignItems: 'center',
        alignContent: "center",
        marginTop: 2,
        p: 1, background: "#fff", fontFamily: "Arial",
        maxWidth: "800px",
        margin: "auto",
        px: 5,
        pb: 5,
        border: "2px solid #e6e6e6ff",
        borderRadius: "12px",
        backgroundColor: "#fff",
      }}>
        <Box sx={{ p: 1 }}>
          <Box sx={{ display: "flex", alignContent: "center", justifyContent: "space-between", flexDirection: "column", alignItems: "center", mb: 1, mt: 5 }}>
            <img
              src={school.logoUrl} // replace with your logo path
              alt="School Logo"
              style={{ width: 100, height: 90, marginTop: 20 }}
            />

            <Typography variant="h4" align="center" fontWeight="bold">
              {toCamelCase(school.schoolName)}
            </Typography>
            <Typography variant="subtitle1" align="center">
              {toCamelCase([school?.addressDTO.addressLine1, school?.addressDTO.city, school?.addressDTO.pincode, school?.addressDTO.state].join(", "))}
            </Typography>
            <Typography variant="subtitle1" align="center" fontWeight="bold">
              PROGRESS REPORT SESSION - {student[0]?.academicYear}
            </Typography>
            <img
              src={student[0]?.photo}
              alt={student[0]?.photo}
              style={{ width: 100, height: 100, marginTop: 10 }}
            />
          </Box>
          <Typography variant="subtitle1" align="center" fontWeight="bold">
            {"STUDENT PROFILE"}
          </Typography>
          <Divider sx={{ mb: 2 }} />

          {/* Student Info */}
          <Box sx={{ display: "flex", justifyContent: "space-around", flexDirection: 'column' }}>
            {studentInfo()}
            <Box display={'flex'} justifyContent={'space-between'}>
              <Typography variant="subtitle1" fontWeight={700}>{"Hight/Weight"}</Typography>
              <TextField
                variant="standard"
                placeholder="..............."
                slotProps={{
                  input: {
                    disableUnderline: true,
                  },
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      <div className="pagebreak"></div>

      <Box sx={{
        p: 1, background: "#fff", fontFamily: "Arial",
        maxWidth: "800px",
        margin: "auto",
        px: 5,
        pb: 5,
        border: "2px solid #e6e6e6ff",
        borderRadius: "12px",
        backgroundColor: "#fff",
      }}
        style={{
          // width: "100%",
          // borderCollapse: "collapse",
          backgroundImage: `url(${school.logoUrl})`,
          // backgroundSize: "150px auto",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundColor: "rgb(255 255 255 / 87%)", // white overlay
          backgroundBlendMode: "lighten"            // makes logo faint
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", flexDirection: "column", alignItems: "center", mb: 1, mt: 0 }}>
          {/* <img
          src={school.logoUrl} // replace with your logo path
          alt="School Logo"
          style={{ width: 80, height: 70, marginTop: 10 }}
        /> */}

          <Typography variant="h6" align="center" fontWeight="bold">
            {toCamelCase(school.schoolName)}
          </Typography>
          <Typography variant="subtitle1" align="center">
            {toCamelCase([school.addressLine2, school.city, school.postalCode, school.state].join(", "))}
          </Typography>
          <Typography
            // variant="subtitle1"
            align="center"
            sx={{ fontWeight: "bold", my: 1 }}
          >
            PROGRESS REPORT SESSION - {student[0]?.academicYear}
          </Typography>
        </Box>
        <Divider sx={{ mb: 2, mt: 1 }} />
        {/* Student Info */}
        {/* studentName: [room?.name, room?.father, room?.last].filter(Boolean).join(" ") */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Typography><strong>Student's Name: </strong> {toCamelCase(`${[student[0]?.name, student[0]?.father, student[0]?.last].filter(Boolean).join(" ")}`)}</Typography>
          <Typography><strong>Standard: </strong>{student[0]?.classRoom?.standard} | {student[0]?.classRoom?.section}</Typography>
          <Typography><strong>Roll No.: </strong> {student[0]?.classRoom?.id}</Typography>
        </Box>
        <Divider sx={{ m: 1 }} />
        {/* Marks Table */}
        <Box sx={{ py: 2, mb: 3 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} rowSpan={2} align="center">
                  <strong>Subject</strong>
                </TableCell>

                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} colSpan={4} align="center">
                  <strong>Term-I</strong>
                </TableCell>
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} colSpan={4} align="center">
                  <strong>Term-II</strong>
                </TableCell>
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} colSpan={4} align="center">
                  <strong>Final Exam</strong>
                </TableCell>
              </TableRow>

              <TableRow>
                {[...Array(3)].flatMap(() => [
                  <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">Max</TableCell>,
                  <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">Min</TableCell>,
                  <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">Obt</TableCell>,
                  <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">Grade</TableCell>,
                ])}
              </TableRow>
            </TableHead>

            <TableBody>
              {subjects.map((sub, i) => {
                const term1 = findMark("First", sub.subjectName);
                const term2 = findMark("Second", sub.subjectName);
                const finalExam = findMark("Final", sub.subjectName);

                return (
                  <TableRow key={i}>
                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>{toCamelCase(sub.subjectName)}</TableCell>

                    {/* Term-I */}
                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{term1?.maxMark || 100}</TableCell>
                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{term1?.maxMark * 34 / 100 || 35}</TableCell>
                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{term1?.marksObtained || "-"}</TableCell>
                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{term1?.grade || "-"}</TableCell>

                    {/* Term-II */}
                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{term2?.maxMark || 100}</TableCell>
                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{term2?.maxMark * 34 / 100 || 35}</TableCell>
                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{term2?.marksObtained || "-"}</TableCell>
                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{term2?.grade || "-"}</TableCell>

                    {/* Final Exam */}
                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{finalExam?.maxMark || 100}</TableCell>
                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{finalExam?.maxMark * 34 / 100 || 35}</TableCell>
                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{finalExam?.marksObtained || "-"}</TableCell>
                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{finalExam?.grade || "-"}</TableCell>

                  </TableRow>
                );
              })}

              {/* Totals Row */}
              <TableRow sx={{ background: "#fff" }}>
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }}><strong>Total Marks</strong></TableCell>

                {/* Term-I */}
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{t1.max}</TableCell>
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} />
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{t1.obt}</TableCell>
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{t1.grade}</TableCell>

                {/* Term-II */}
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{t2.max}</TableCell>
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} />
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{t2.obt}</TableCell>
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{t2.grade}</TableCell>

                {/* Final Exam */}
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{t3.max}</TableCell>
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} />
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{t3.obt}</TableCell>
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{t3.grade}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>

        {/* Result Section */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Typography variant="body2"><strong>Result:</strong> {student[2]?.result}</Typography>
          <Typography variant="body2" color="textSecondary">
            <b>Remarks: </b>{student[2]?.remarks}</Typography>
          <Typography variant="body2"><strong>Percentage:</strong> {student[2]?.percentage}%</Typography>
        </Box>

        {/* <Divider sx={{ mb: 2 }} /> */}

        {/* Footer */}
        <Box my={8} display="flex" justifyContent="space-between">
          <Typography variant="body2">Signature: ___________________</Typography>
          <Typography variant="body2">Class Teacher Sign.: ___________________</Typography>
          <Box>
            <Typography variant="body2" sx={{ fontWeight: "bold" }}> Principal/HeadMaster </Typography>
            <Typography variant="body2">Seal/Sign.: ___________________</Typography></Box>
        </Box>
      </Box>
    </Box>
  );
}
export default SinglePageMarksheetReceipt;